// Feature string files are merged over the base dictionary in i18n.js.
// Keep each feature's strings in its own file so parallel work doesn't collide.
import shared from "./shared";
import team from "./team";
import followups from "./followups";
import settings from "./settings";
import appointments from "./appointments";
import patients from "./patients";
import home from "./home";
import admin from "./admin";
import landing from "./landing";
import security from "./security";

const all = [shared, team, followups, settings, appointments, patients, home, admin, landing, security];

export const extraStrings = {
  es: Object.assign({}, ...all.map((m) => m.es)),
  en: Object.assign({}, ...all.map((m) => m.en)),
};
